var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.993,
    height: 14.695,
    viewBox: "0 0 20.993 14.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wifi",
    "data-name": "Icon awesome-wifi",
    d: "M20.826,6.281a15.252,15.252,0,0,0-20.659,0,.521.521,0,0,0-.011.754L1.279,8.149a.533.533,0,0,0,.735.012,12.585,12.585,0,0,1,16.967,0,.533.533,0,0,0,.735-.012l1.123-1.114a.522.522,0,0,0-.012-.754ZM10.5,12.747a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,10.5,12.747ZM17.145,10a10.07,10.07,0,0,0-13.3,0,.519.519,0,0,0-.019.759l1.13,1.115a.535.535,0,0,0,.723.026,7.388,7.388,0,0,1,9.627,0,.535.535,0,0,0,.723-.026l1.13-1.115A.519.519,0,0,0,17.145,10Z",
    transform: "translate(0 -2.25)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.81c3bf8a8f5fcd96d3963f5b28c2783c.svg";
export { ForwardRef as ReactComponent };